import { Component, ChangeDetectionStrategy } from '@angular/core'
import { CoreService, NotificationService } from '../../../services'
import { OrderDetailService } from '../../../services/order-detail.service'
import { File } from 'depoto-core/src/entities'
import { SchemaUtil } from '../../../utils'

@Component({
  selector: 'app-order-form',
  templateUrl: './order-form.component.html',
  styleUrls: ['./order-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OrderFormComponent {
  constructor(
    private core: CoreService,
    public orderDetailService: OrderDetailService,
    private notificationService: NotificationService
  ) {}

  refreshData(id) {
    if (id) {
      this.orderDetailService.refreshData(id)
    }
  }

  fileAdded(file: File) {
    if (this.order.id) {
      // save with order's id
      try {
        this.core.services.file
          .update(file, null, this.order.id, null, null, null, SchemaUtil.fileExtra)
          .then(createdFile => {
            this.orderDetailService.order.files.push(createdFile)
          })
      } catch (error) {
        console.error('Error in function connectUploadedFilesToOrder. Details: ', error.message)
      }
    } else {
      this.orderDetailService.order.files.push(file)
    }
  }

  public refreshPaymentAmount(): void {
    if (this.order.paymentItems && this.order.paymentItems.length === 1) {
      const itemPrices = this.order.items.map(item => item.priceAll)
      this.orderDetailService.order.paymentItems[0].amount = itemPrices.reduce((a, b) => a + b, 0)
    }
    // todo add to tests
    // if (this.orderDetailService.order.customer?.priceLevel?.id) {
    //   this.recalculatePricesByPriceLevel()
    // }
  }

  public recalculatePricesByChangedCurrency() {
    if (
      this.orderDetailService.newCurrency.id === this.orderDetailService.order.currency.id ||
      !this.orderDetailService.newCurrency.id
    )
      return

    if (this.orderDetailService.order.currency.id === 'CZK') {
      // if from czk use ratio
      for (const orderItem of this.orderDetailService.order.items) {
        orderItem.price = Number((orderItem.price * this.orderDetailService.newCurrency.ratio).toFixed(2))
        orderItem.priceAll = Number((orderItem.price * orderItem.quantity).toFixed(2))
      }
      for (const paymentItem of this.orderDetailService.order.paymentItems) {
        paymentItem.amount = Number((paymentItem.amount * this.orderDetailService.newCurrency.ratio).toFixed(2))
        this.orderDetailService.order.currency = this.orderDetailService.newCurrency
      }
    } else {
      // if not from czk, recalculate to czk and then use ratio
      for (const orderItem of this.orderDetailService.order.items) {
        // to czk
        const priceInCzk = orderItem.price / this.orderDetailService.order.currency.ratio

        orderItem.price = Number((priceInCzk * this.orderDetailService.newCurrency.ratio).toFixed(2))
        orderItem.priceAll = Number((priceInCzk * orderItem.quantity).toFixed(2))
      }
      for (const paymentItem of this.orderDetailService.order.paymentItems) {
        // to czk
        const amountInCzk = paymentItem.amount / this.orderDetailService.order.currency.ratio

        paymentItem.amount = Number((amountInCzk * this.orderDetailService.newCurrency.ratio).toFixed(2))
        this.orderDetailService.order.currency = this.orderDetailService.newCurrency
      }
    }

    this.notificationService.success('Ceny úspěšně přepočítány.')
  }

  public async recalculatePricesByPriceLevel() {
    if (this.orderDetailService.order.customer?.id && this.orderDetailService.order.customer.priceLevel?.id) {
      for (const orderItem of this.orderDetailService.order.items) {
        if (orderItem.product?.id) {
          await this.core.services.product
            .getProductSellPrice(
              orderItem.product.id,
              this.orderDetailService.order.currency.id,
              this.orderDetailService.order.customer.priceLevel.id
            )
            .then(result => {
              if (this.orderDetailService.order.customer.priceLevel.withVat) {
                orderItem.price = result.sellPrice
                orderItem.priceAll = Number(orderItem.price) * Number(orderItem.quantity)
              } else {
                orderItem.price = result.sellPriceWithoutVat
                orderItem.priceAll = Number(orderItem.price) * Number(orderItem.quantity)
              }
            })
        }
      }
    }
  }

  async removeStatusFromError(event) {
    const lastStatusBeforeError =
      this.orderDetailService.order.processStatusRelations[
        this.orderDetailService.order.processStatusRelations?.length - 2
      ]
    // const lastStatusBeforeError = this.processStates[this.processStates?.length - 2]
    if (lastStatusBeforeError?.status?.id) {
      this.orderDetailService.order.processStatusRelation.status.id = lastStatusBeforeError.status.id
      this.orderDetailService.order.processStatusRelation.status.name = lastStatusBeforeError.status.name
    } else {
      this.orderDetailService.order.processStatusRelation.status.id = 'recieved'
      this.orderDetailService.order.processStatusRelation.status.name = 'Přijatá'
    }
    this.orderDetailService.order.processStatusRelation.note = event
    this.orderDetailService.updateProcessStatus = this.orderDetailService.order.processStatusRelation.status.id
  }

  get order() {
    return this.orderDetailService.order
  }
}
